import { Injectable, inject } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

export interface ConfirmOptions {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  type?: 'danger' | 'warning' | 'info';
}

@Injectable({
  providedIn: 'root'
})
export class ConfirmService {
  private toastr = inject(ToastrService);
  private confirmSubject = new Subject<{ options: ConfirmOptions; resolve: (result: boolean) => void }>();
  confirm$ = this.confirmSubject.asObservable();

  confirm(options: string | ConfirmOptions): Promise<boolean> {
    const opts: ConfirmOptions = typeof options === 'string' ? { message: options } : options;
    
    return new Promise((resolve) => {
      this.confirmSubject.next({ options: opts, resolve });
    });
  }

  /**
   * Shows a toast notification.
   * If a blocking alert is strictly needed, use confirm() with only one button.
   */
  alert(message: string, title: string = 'Notice', type: 'success' | 'error' | 'info' | 'warning' = 'info'): void {
    console.log(`Toastr alert triggered: ${type} - ${message}`);
    this.toastr[type](message, title);
  }

  success(message: string, title: string = 'Success'): void {
    this.toastr.success(message, title);
  }

  error(message: string, title: string = 'Error'): void {
    this.toastr.error(message, title);
  }

  warning(message: string, title: string = 'Warning'): void {
    this.toastr.warning(message, title);
  }
}
